import { html } from "@microsoft/fast-element";
/**
 * Generates the template for the {@link @fabric-msft/fabric-web#MultiViewController} component.
 *
 * @public
 * @remarks
 * This template provides the HTML structure and bindings for the `MultiViewController` component.
 * It includes a slot for the controller content and assigns the role of "tab" for accessibility.
 *
 * @returns {ElementViewTemplate<MultiViewController>} The template for the `MultiViewController` component.
 *
 * @slot controller - Slot for the controller content.
 */
function multiViewControllerTemplate() {
    return html `
    <template slot="controller" role="tab">
      <slot></slot>
    </template>
  `;
}
/**
 * The template for the {@link @fabric-msft/fabric-web#MultiViewController} component.
 * @public
 */
export const template = multiViewControllerTemplate();
//# sourceMappingURL=multi-view-controller.template.js.map